import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link
} from 'react-router-dom'
// import ReallySmoothScroll from 'really-smooth-scroll'

// material
import CssBaseline from '@material-ui/core/CssBaseline';

import './App.css';
import Home from './Components/Home/Home'
import Portfolio from './Components/Portfolio/Portfolio'
import Footer  from './Components/Footer/Footer'


// THEME
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import theme from './theme';

export default class App extends Component {

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
        <CssBaseline />        
          <Router>
            <Switch>
             <Route path="/" exact component={Home} />
             <Route path="/portfolio" exact component={Portfolio} />
             <Route path="*" component={Home} />
            </Switch>
          </Router>
         <Footer />
        </div>
      </MuiThemeProvider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.js